import config from '@/config'
import moment from 'moment'
import { Modal } from 'view-design'
import routers from '@/router'

const { appTitle } = config
const DATE_TIME_FORMAT = 'YYYY-MM-DD'

/**
 * Get route item title which will be shown in browser
 * @param {Object} routeItem route item
 */
export const getRouteItemTitle = (routeItem) => {
  return (routeItem.meta && routeItem.meta.title) || routeItem.name
}

/**
 * Set browser title by given route item
 * @param {Object} routeItem route item
 */
export const setTitle = (routeItem) => {
  const pageTitle = getRouteItemTitle(routeItem)
  window.document.title = pageTitle ? `${appTitle} - ${pageTitle}` : appTitle
}

/**
 * Turn to the given route
 * @param {Object} routeItem route item
 * @param {Object} router router instance
 */
export const turnToPage = (routeItem, router) => {
  let { name, params, query } = {}
  if (typeof routeItem === 'string') name = routeItem
  else {
    name = routeItem.name
    params = routeItem.params
    query = routeItem.query
  }
  router.push({
    name,
    params,
    query
  })
}

/**
 * get timestamp diff
 * @param {Date} start
 * @param {Date} end
 */
export const getTimeDiff = (start, end) => {
  var timeDiff = new Date(end).getTime() - new Date(start).getTime()

  var hourLeave = timeDiff % (24 * 3600 * 1000)
  var minLeave = hourLeave % (3600 * 1000)
  var secLeave = minLeave % (60 * 1000)

  var hours = Math.floor(hourLeave / (3600 * 1000))
  var mins = Math.floor(minLeave / (60 * 1000))
  var seconds = Math.round(secLeave / 1000)
  return paddingNum(hours) + ':' + paddingNum(mins) + ':' + paddingNum(seconds)
}

/**
 * get fist day in current month
 */
export const getMonthFirstDay = () => {
  const date = new Date()
  const monthStart = date.setDate(1)
  return moment(monthStart).format(DATE_TIME_FORMAT)
}

// 判断参数是否是其中之一
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

/**
 * get current day in current month
 */
export const getCurrentDay = () => {
  return moment(new Date()).format(DATE_TIME_FORMAT)
}

/**
 * get last day in current month
 */
export const getMonthLastDay = () => {
  const date = new Date()
  let currentMonth = date.getMonth()
  const nextMonth = ++currentMonth
  const nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  const oneDay = 1000 * 60 * 60 * 24
  return moment(nextMonthFirstDay - oneDay).format(DATE_TIME_FORMAT)
}

export const isBefore = (date) => {
  return moment(new Date()).isBefore(date)
}

export const isAfter = (startDate, endDate) => {
  return moment(startDate).isAfter(endDate)
}

/**
 * padding num
 */
export const paddingNum = (value) => {
  return parseInt(value) < 10 ? '0' + value : value
}

/**
 * get file size
 * @param {Integer} size
 */
export const getFileSize = (size) => {
  var kbytes = 1024
  var mbytes = kbytes * 1024
  if (size && size > 0) {
    if (size / mbytes > 1) {
      return Math.abs(size / mbytes).toFixed(2) + ' MB'
    } else if (size / kbytes > 1) {
      return Math.abs(size / kbytes).toFixed(2) + ' KB'
    } else {
      return size + ' bytes'
    }
  } else {
    return '0 bytes'
  }
}

/**
 * get status text by given status code
 * @param {Integer} statusCode
 */
export const getStatusText = (statusCode) => {
  switch (statusCode) {
    case 0:
      return 'skipped'
    case 1:
      return 'success'
    case 2:
      return 'failed'
    case 3:
      return 'warning'
    default:
      return 'skipped'
  }
}

/**
 * show modal dialog before closing tab
 */
export const beforeClose = {
  before_close_normal: (resolve) => {
    Modal.confirm({
      title: '确定要关闭这一页吗?',
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      }
    })
  }
}

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
export const routeEqual = (route1, route2) => {
  const params1 = route1.params || {}
  const params2 = route2.params || {}
  const query1 = route1.query || {}
  const query2 = route2.query || {}
  return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
}

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) return false
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true
  /* eslint-disable-next-line */
  else return !keysArr1.some(key => obj1[key] != obj2[key])
}

export const showTitle = (item, vm) => {
  const { title } = item.meta
  if (!title) return
  // if (useI18n) {
  //   if (title.includes('{{') && title.includes('}}') && useI18n) title = title.replace(/({{[\s\S]+?}})/, (m, str) => str.replace(/{{([\s\S]*)}}/, (m, _) => vm.$t(_.trim())))
  //   else if (__titleIsFunction__) title = item.meta.title
  //   else title = vm.$t(item.name)
  // } else title = (item.meta && item.meta.title) || item.name
  return title
}

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
  let i = -1
  while (++i < times) {
    callback(i)
  }
}

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
export const routeHasExist = (tagNavList, routeItem) => {
  const len = tagNavList.length
  let res = false
  doCustomTimes(len, (index) => {
    if (routeEqual(tagNavList[index], routeItem)) res = true
  })
  return res
}

export const getRouteTitleHandled = (route) => {
  const router = { ...route }
  const meta = { ...route.meta }
  let title = ''
  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      title = meta.title(router)
    } else title = meta.title
  }
  meta.title = title
  router.meta = meta
  return router
}

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = (routers, homeName = 'Home') => {
  let i = -1
  const len = routers.length
  let homeRoute = {}
  while (++i < len) {
    const item = routers[i]
    if (item.children && item.children.length) {
      const res = getHomeRoute(item.children, homeName)
      if (res.name) return res
    } else {
      if (item.name === homeName) homeRoute = item
    }
  }
  return homeRoute
}

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
export const getNextRoute = (list, route) => {
  let res = {}
  if (list.length === 2) {
    res = getHomeRoute(list)
  } else {
    const index = list.findIndex(item => routeEqual(item, route))
    if (index === list.length - 1) res = list[list.length - 2]
    else res = list[index + 1]
  }
  return res
}

/**
 *
 * @param {Object} source
 * @param {Object} target
 */
export const applyObject = (source, target) => {
  for (const key of Object.keys(source)) {
    if (target.hasOwnProperty(key) && (source[key] || source[key] === 0)) {
      target[key] = source[key]
    }
  }
  return target
}

/**
 * Get router name by given path
 *
 * @param {String} path router path
 */
export const getRouterNameByPath = (path) => {
  if (routers.options && routers.options.routes) {
    for (const route of routers.options.routes) {
      if (route.path === path) {
        return route.name
      } else {
        if (route.children && route.children.length > 0) {
          for (const child of route.children) {
            if (child.path === path) {
              return child.name
            }
          }
        }
      }
    }
  }
  return null
}

export const formatDate = (date, fmt) => {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 获取车库车辆编码号段区间
 */
export const getParkingSegmentRange = (start, capacity) => {
  const length = config.planetNumberLength
  const prefix = config.planetNumberPrefix
  const startSegment = prefix + (Array(length).join('0') + start).slice(-length)
  const endSegment = prefix + (Array(length).join('0') + (start + capacity - 1)).slice(-length)
  return startSegment + ' - ' + endSegment
}

/**
 * 获取文件路径
 * @param {*} fileId
 * @param {*} fileType
 */
export const getImagePath = (fileId, fileType = 'photo') => {
  const extension = config.imageFileExt
  const storageHost = config.storageHost
  return `${storageHost}/${fileType}/${fileId}/${fileId}${extension}`
}

export function getLinkTextStyle(condition) {
  return {
    color: condition ? '#126D91' : '#9c9c9c',
    marginRight: '10px',
    cursor: condition ? 'pointer' : 'not-allowed'
  }
}

/**
 * format file size
 *
 * @param {Integer} size
 * @param {*} pointLength
 */
export const formatFileSize = (size, pointLength) => {
  var unit
  const units = ['K', 'M', 'G', 'TB']
  while ((unit = units.shift()) && size > 1024) {
    size = size / 1024
  }
  return (unit === 'B' ? size : size.toFixed(pointLength === undefined ? 2 : pointLength)) + unit
}

/**
 * 日期格式化
 */
export function dateFormat(date, dateFormat = 'yyyy-MM-dd hh:mm:ss') {
  let format = dateFormat || 'yyyy-MM-dd'
  if (date !== 'Invalid Date') {
    var o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      'S': date.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return format
  }
  return ''
}

export function htmlEncode(html) {
  // 1.首先动态创建一个容器标签元素，如DIV
  var temp = document.createElement('div');
  // 2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(旧版火狐，google支持)
  (temp.textContent !== undefined) ? (temp.textContent = html) : (temp.innerText = html)
  // 3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
  var output = temp.innerHTML
  temp = null
  return output
}

export function htmlDecode(text) {
  // 1.首先动态创建一个容器标签元素，如DIV
  var temp = document.createElement('div')
  // 2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
  temp.innerHTML = text
  // 3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
  var output = temp.innerText || temp.textContent
  temp = null
  return output
}

export function getLabelByCode(code, objectData, defaultLabel = '---') {
  const matched = objectData.filter(t => t.value === code)
  return matched && matched.length > 0 ? matched[0].label : defaultLabel
}
